<template>
  <!--<div id="app">-->
    <!--<img src="./assets/logo.png">-->
    <router-view/>
  <!--</div>-->
</template>

<script>
export default {
  name: 'App',
  beforeMount() {
    //console.log(this.$cookie.get('lang'));
//    if (this.$cookie.get('lang') == null || this.$cookie.get('lang') == undefined){
      //Vue.i18n.fallback('en');
//      this.$store.dispatch('lang', 'en');
//      this.$cookie.set('lang', 'en', 1)
//    } else {
//      this.$store.dispatch('lang', this.$cookie.get('lang'));
//    }
    //Vue.i18n.set(this.$cookie.get('lang'));
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue